import { useFormContext } from "react-hook-form";
import styles from "./CustomActivityDuration.module.scss";
import { Trans, useLingui } from "@lingui/react/macro";
import ErrorMessage from "@medoma/components/ErrorMessage/ErrorMessage";
import InputField from "@medoma/components/InputField/InputField";
import Select from "@medoma/components/Select/Select";
import {
  customDurationUnitOptions,
  customDurationUnitDictionary,
  type ICustomDurationUnit,
} from "./activityDurationModels";

export type ICustomActivityDurationFields = {
  customDuration: string | null;
  customDurationUnit: ICustomDurationUnit | null;
};

export const CustomActivityDuration = () => {
  const { t } = useLingui();
  const {
    formState: { errors },
    register,
  } = useFormContext<ICustomActivityDurationFields>();

  return (
    <fieldset className={styles.fieldset}>
      <legend className={styles.legend}>
        <Trans>Annan tid</Trans>
      </legend>
      {errors.customDuration?.message ? (
        <div className={styles.errorMessage}>
          <ErrorMessage message={errors.customDuration.message} weight="bold" />
        </div>
      ) : null}
      {errors.customDurationUnit?.message ? (
        <div className={styles.errorMessage}>
          <ErrorMessage
            message={errors.customDurationUnit.message}
            weight="bold"
          />
        </div>
      ) : null}
      <div className={styles.inputWrapper}>
        <InputField
          label={t`Annan tid`}
          hideLabel
          showOptionalLabel={false}
          type="number"
          outerWidth="fit"
          inputWidth="8ch"
          {...register("customDuration", {
            required: {
              value: true,
              message: t`Ange tidsåtgång`,
            },
            min: {
              value: 1,
              message: t`Tidsåtgången måste vara minst 1 minut`,
            },
          })}
        />
        <Select
          label={t`Enhet för tidsåtgång`}
          hideLabel
          {...register("customDurationUnit")}
        >
          {customDurationUnitOptions.map((unit) => (
            <option key={unit} value={unit}>
              {t(customDurationUnitDictionary[unit])}
            </option>
          ))}
        </Select>
      </div>
    </fieldset>
  );
};
